import { useThreads } from "@liveblocks/react";
import { useMemo } from "react";

import type { MirroredThread } from "../context/CanvasCommentsMirrorContext";

/**
 * The room's threads, unfiltered, plus the plain projection the rail mirror
 * carries. One `useThreads` subscription serves the pin layer, the thread
 * window and the rail.
 */
export function useCanvasCommentThreads() {
  const { threads, isLoading } = useThreads();

  const mirrored = useMemo<MirroredThread[]>(
    () =>
      (threads ?? []).map((thread) => ({
        id: thread.id,
        resolved: !!thread.resolved,
        metadata: thread.metadata,
        comments: thread.comments.map((comment) => ({
          id: comment.id,
          userId: comment.userId,
          createdAt: comment.createdAt.toISOString(),
          deletedAt: comment.deletedAt?.toISOString(),
        })),
      })),
    [threads],
  );

  return { threads: threads ?? [], isLoading, mirrored };
}
